import React from "react";
import {
  FaHome,
  FaArrowLeft
} from "react-icons/fa";
import { useHistory } from "react-router-dom";
const OperationResult = (props) => {
  const history = useHistory();
  const { success,message } = (props.location && props.location.state) || {};
  return (
    <center >
    {success &&   <img src="/images/success.png" style={{height:"200px",width:"200px"}}  ></img> }
    {!success &&   <img src="/images/failure.png" style={{height:"200px",width:"200px"}}></img> }


      <h1 style={{ color: "grey" }}>{message}</h1>

      <br/> <br/> <br/> <br/>

      <button className="btn btn-default"   onClick={() => {
                history.goBack();
              }} ><FaArrowLeft></FaArrowLeft> &nbsp; Back </button> 
&nbsp;&nbsp;&nbsp;
      <button className="btn btn-default" onClick={() => {
                   history.push("/");
              }}> <FaHome></FaHome>&nbsp; HOME </button>
    </center>
  );
};

export default OperationResult;
